function isBoolean(value) {
    return value === 'true' || value === 'false';
}
export function BooleanAttributeChangedMixin(Base) {
    return class extends Base {
        attributeChangedCallback(propertyName, oldValue, newValue) {
            super.attributeChangedCallback(propertyName, oldValue, newValue);
            if (propertyName.startsWith('aria-')) {
                return;
            }
            if (isBoolean(newValue)) {
                if (newValue === 'true') {
                    this.setAttribute(propertyName, '');
                }
                else {
                    this.removeAttribute(propertyName);
                }
            }
        }
    };
}
function ChameleonVersionMixin(Base) {
    return class extends Base {
        get chameleonVersion() {
            return `@getgo/chameleon-web 0.187.1`;
        }
    };
}
export function ChameleonElementMixin(Base) {
    return class extends ChameleonVersionMixin(BooleanAttributeChangedMixin(Base)) {
    };
}
